module.exports = __webpack_public_path__ + "img/logo-Allianz.36862b5e.png";